const getBackgroundColor = (colors, type) => {
    switch (type) {
        case 'success':
            return colors.status.success.gamma;
        case 'warn':
            return colors.status.warn.gamma;
        case 'fail':
            return colors.status.fail.alpha;
        case 'brand':
            return colors.brand.primary.beta;
        case 'bold':
            return colors.brand.primary.alpha;
        default:
            // 'modal'
            return 'rgba(67, 67, 67, 0.7)';
    }
};
export default getBackgroundColor;
//# sourceMappingURL=getBackgroundColor.js.map